import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  Scrolling,
  SearchPanel,
} from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import {
  DefaultDateFormat,
  AssetSubStatus,
  Features,
} from "../../../helper/fixcode";
import moment from "moment";
import {
  DateBox,
  NumberBox,
  SelectBox,
  Template,
  TextArea,
  TextBox,
} from "devextreme-react";
import "./../../../App.css";
import Modal from "react-modal";
import { Icon } from "@iconify/react/dist/iconify.js";
import { categoryService } from "../../../apis/apiServices/Category";
import { subCategoryService } from "../../../apis/apiServices/SubCategory";
import {
  askConfirmation,
  showErrorMessage,
  showResponseMessage,
  showWarningMessage,
} from "../../../helper/message.js";
import Swal from "sweetalert2";
import { assetService } from "../../../apis/apiServices/Asset";
import { assetLocationService } from "../../../apis/apiServices/AssetLocation";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi.js";
import secureLocalStorage from "react-secure-storage";
import { Loader } from "../../Shared/PageLoader";

const requestTypeDropdown = [
  { id: 1, name: "Scrap" },
  { id: 2, name: "Movement" },
  { id: 3, name: "Issue" },
];

export default function AddAssetRequestComponent(props) {
  const user = useSelector((state) => state.user.data);
  const userPayload = secureLocalStorage.getItem("user");
  const userCompany = useSelector((state) => state.company.data);

  const navigate = useNavigate();
  const [state, setState] = useState({
    isSending: false,
    isSavingAsDraft: false,
    isSaveAssetModalOpen: false,
    isAssetSubmitted: false,
    categoryId: 0,
    categoryName: "",
    subCategoryId: 0,
    subCategoryName: "",
    requiredQty: 1,
    durationInMonths: 0,
    requirementDate: "",
    purpose: "",
    note: "",
    assetLst: [],
    projectId: 0,
    userId: 0,
    requestNo: "",
    isSubmitted: false,
    requestSubject: "",
    requestTypeId: 0,
    requestId: 0,
    locationName: "",
    workflowCategoryId: 0,
    workflowDepartmentId: 0,
    workflowId: 0,
    stageApproved: false,
    isCompleteLoading: false,
    loadingMessage: "",
    statusId: 0,
  });

  const [categoryDropdown, setCategoryDropdown] = useState([]);
  const [subCategoryDropdown, setSubCategoryDropdown] = useState([]);
  const location = useLocation();
  const sourceUrl = location.state || {};
  //const stateData = location.state?.stateData || null;
  //console.log(JSON.stringify(stateData));
  const [projectDropdown, setProjectDropdown] = useState([]);
  const [workflowData, setWorkflowData] = useState([]);
  const [assetRequestApproversByWorkflow, setAssetRequestApproversByWorkflow] = useState([]);
  const [assetRequestApprovers, setAssetRequestApprovers] = useState([]);
  const [workflowDepartmentDropdown, setWorkflowDepartmentDropdown] = useState([]);

  const [assetDocumentTypeDropdown, setAssetDocumentTypeDropdown] = useState([]);
  const [workflowCategoryDropdown, setWorkflowCategoryDropdown] = useState([]);
  const [userDropdown, setUserDropdown] = useState([]);
  const [showAttachmentGrid, setShowAttachmentGrid] = useState(false);
  const [files, setFiles] = useState([]);
  const [removedAttachmentIds, setRemovedAttachmentIds] = useState([]);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Add Asset Request";
  }, []);

  const [assetAttachment, setAssetAttachment] = useState({
    documentTypeId: 0,
    documentTypeName: "",
    fileTypeName: "",
    fileName: "",
    fileUrl: "",
    fileData: "",
    extension: "",
    fileSize: 0,
    isIssueDateEnable: false,
    issueDate: "",
    isExpiryDateEnable: false,
    expiryDate: "",
    isReminderAlertEnable: false,
    reminderAlertDays: 0,
    remark: "",
    isUploaded: false,
    uploadedTemporaryAttachmentLst: [],
    //uploadedTemporaryAttachmentLst: stateData !== null ? stateData.assetRequestAttachments ?? [] : [],
    assetRequestId: 0,
  });

  const [errors, setErrors] = useState({
    categoryValidation: "",
    subCategoryValidation: "",
    //requiredQtyValidation: "",
    durationInMonthsValidation: "",
    requirementDateValidation: "",
    purposeValidation: "",
    //noteValidation: "",
    fileNameValidation: "",
    projectValidation: "",
    //userValidation: "",
    subjectValidation: "",
    requestValidation: 0,
    workflowCategoryValidation: "",
    workflowDepartmentValidation: "",
  });

  var isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    if (location?.state?.requestId > 0) {
      GetWorkFlowForApprovers(
        state.workflowCategoryId,
        state?.projectId,
        state?.departmentId
      );
    } else {
      GetWorkFlowForApprovers(
        state.workflowCategoryId,
        state?.projectId,
        state?.workflowDepartmentId
      );
    }
  }, [
    state?.workflowCategoryId,
    state?.projectId,
    state?.workflowDepartmentId,
  ]);

  const fetchApiOnPageLoad = useCallback(async () => {
    setState((prev) => ({ ...prev, isCompleteLoading: true }));

    try {
      // await getProjectDropdown();

      let stateData = null;
      if (location?.state?.requestId > 0) {
        const assetRequestResponse = await assetService.getassetDetailsById(
          location.state.requestId,
          user.userId
        );

        stateData = assetRequestResponse?.data;
        await getProjectDropdown(stateData?.projectId);

        if (stateData) {
          setState((prev) => ({
            ...prev,
            projectId: stateData.projectId,
            userId: stateData.toId,
            note: stateData.note,
            requestNo: stateData.requestNo,
            durationInMonths: stateData.durationInMonths,
            statusId: stateData.statusId,
            fromId: stateData.fromId,
            requestedDate: stateData.requestedDate,
            assetRequestId: stateData.requestId,
            requestSubject: stateData.requestSubject,
            requestTypeId: stateData.requestTypeId,
            requestId: stateData.requestId,
            locationName: stateData.locationName,
            workflowCategoryId: stateData.categoryId,
            workflowId: stateData.workflowId,
            workflowDepartmentId: stateData.departmentId,
            stageApproved: stateData.stageApproved,
            statusId: stateData.statusId,
          }));
        }
      } else {
        await getProjectDropdown(0);
      }

      if (stateData?.requestId > 0) {
        // Run workflow + sublist in parallel
        const [assetRequestSubResponse] = await Promise.all([
          assetService.addAssetRequestSubList(0, stateData.requestId),
          GetWorkFlowForApprovers(
            stateData.categoryId,
            stateData.projectId,
            stateData.departmentId
          ),
        ]);

        setAssetAttachment((prev) => ({
          ...prev,
          uploadedTemporaryAttachmentLst:
            stateData.assetRequestAttachments || [],
        }));

        setState((prev) => ({
          ...prev,
          assetLst: assetRequestSubResponse.data,
        }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      // ✅ Loading ends only after ALL awaits finish
      setState((prev) => ({ ...prev, isCompleteLoading: false }));
    }
  }, []);

  // const fetchApiOnPageLoad = useCallback(async () => {
  //   try {
  //     setState((prevState) => ({
  //       ...prevState,
  //       isCompleteLoading: true,
  //     }));

  //     await getProjectDropdown();

  //     if (location?.state?.requestId > 0) {
  //       var assetRequestResponse = await assetService.getassetDetailsById(
  //         location.state.requestId,
  //         user.userId
  //       );

  //       var stateData = assetRequestResponse?.data;
  //       //console.log(stateData);
  //       debugger;
  //       if (stateData !== null) {
  //         setState({
  //           projectId: stateData.projectId,
  //           userId: stateData.toId,
  //           note: stateData.note,
  //           requestNo: stateData.requestNo,
  //           durationInMonths: stateData.durationInMonths,
  //           statusId: stateData.statusId,
  //           fromId: stateData.fromId,
  //           requestedDate: stateData.requestedDate,
  //           assetRequestId: stateData.requestId,
  //           requestSubject: stateData.requestSubject,
  //           requestTypeId: stateData.requestTypeId,
  //           requestId: stateData.requestId,
  //           locationName: stateData.locationName,
  //           workflowCategoryId: stateData.categoryId,
  //           workflowId: stateData.workflowId,
  //           workflowDepartmentId: stateData.departmentId,
  //           stageApproved: stateData.stageApproved,
  //         });
  //       }
  //     }

  //     if (stateData?.requestId > 0) {
  //       var assetRequestResponse = await assetService.getassetDetailsById(
  //         stateData?.requestId,
  //         user.userId
  //       );

  //       var assetRequestSubResponse = await assetService.addAssetRequestSubList(
  //         0,
  //         stateData?.requestId
  //       );

  //       setAssetAttachment((prev) => ({
  //         ...prev,
  //         uploadedTemporaryAttachmentLst:
  //           assetRequestResponse?.data?.assetRequestAttachments,
  //       }));

  //       setState((prevState) => ({
  //         ...prevState,
  //         assetLst: assetRequestSubResponse.data, // assuming response.data is the asset array
  //         //uploadedTemporaryAttachmentLst: assetRequestResponse?.data?.assetRequestAttachments,
  //       }));

  //       await GetWorkFlowForApprovers(
  //         stateData.categoryId,
  //         stateData.projectId,
  //         stateData.departmentId
  //       );
  //     }

  //   } catch (error) {
  //     console.log(error);
  //     setState((prev) => ({
  //       ...prev,
  //       isCompleteLoading: false,
  //     }));
  //   }
  //   finally {
  //     setState((prev) => ({
  //       ...prev,
  //       isCompleteLoading: false,
  //     }));
  //   }
  // }, []);

  const getCategoryDropdown = async (departmentId) => {
    try {
      const response = await categoryService.getCategorydrop(departmentId);
      //console.log("getCategoryDropdown: " + response?.data);
      setCategoryDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getSubCategoryDropdown = async (categoryId) => {
    try {
      const response = await subCategoryService.getSubCategoryList();
      //console.log("getSubCategoryDropdown: " + response?.data);
      if (categoryId > 0) {
        setSubCategoryDropdown(
          response?.data?.filter((f) => f.categoryId === categoryId)
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetDocumentTypeDropdown = async () => {
    try {
      const response = await assetService.getAssetDocumentTypeDropdown(0);
      setAssetDocumentTypeDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getWorkflowCategory = async (projectId, departmentId) => {
    try {
      let body = {
        formId: props.featurePermission.featureId,
        projectId: projectId,
        departmentId: departmentId,
      };
      const response = await assetService.getWorkflowGroup(body);
      // const response1 = await vishwamApi.getWorkflowCategories(body);
      //console.log("response: " + JSON.stringify(response));
      //console.log(JSON.stringify(response?.data));
      setWorkflowCategoryDropdown(response?.data);

      if (response?.data.length >= 1) {
        setState((prev) => ({
          ...prev,
          workflowCategoryId: response?.data[0].workflowCategoryId,
          workflowId: response?.data[0].workflowId,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getProjectDropdown = async (projectId) => {
    try {
      let body = { companyId: user?.companyId };
      const response = await vishwamApi.getProjectByUserId(user.userId, body);
      setProjectDropdown(response?.data);
      var project = response?.data?.filter((e) => e.id === 81);

      let selectedProjectId =
        location?.state?.requestId > 0 ? projectId : project[0]?.id;

      //await getWorkflowCategory(project[0]?.id);
      await getWorkflowDepartmentDropdown(selectedProjectId);
      setState((prev) => ({
        ...prev,
        projectId: selectedProjectId,
        locationName: project[0]?.location ?? "",
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getWorkflowDepartmentDropdown = async (projectId) => {
    try {
      let body = {
        formId: props.featurePermission.featureId,
        projectId: projectId,
        companyId: user?.companyId,
      };
      const response = await vishwamApi.getDepartmentDropdownForWorkFlow(body);
      setWorkflowDepartmentDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getUserDropdown = async () => {
    try {
      const response = await vishwamApi.getUserList();
      setUserDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const isValidAddAssetData = () => {
    let isvalid = true;
    try {
      let err = { ...errors };
      err.categoryValidation = "";
      err.subCategoryValidation = "";
      //err.requiredQtyValidation = "";
      err.durationInMonthsValidation = "";
      err.requirementDateValidation = "";
      err.purposeValidation = "";
      err.workflowCategoryValidation = "";
      err.workflowDepartmentValidation = "";

      if (state.categoryId === 0) {
        err.categoryValidation = "Please select category.";
        isvalid = false;
      }
      if (state.workflowDepartmentId === 0) {
        err.workflowDepartmentValidation = "Please select department.";
        isvalid = false;
      }
      if (state.subCategoryId === 0) {
        err.subCategoryValidation = "Please select sub category.";
        isvalid = false;
      }
      if (state.workflowCategoryId === 0) {
        err.workflowCategoryValidation = "Please select workflow category.";
        isvalid = false;
      }
      // if (!state.requiredQty || state.requiredQty === 0) {
      //   err.requiredQtyValidation = "Please enter required qty.";
      //   isvalid = false;
      // }
      // if (!state.durationInMonths || state.durationInMonths === 0) {
      //   err.durationInMonthsValidation =
      //     "Please enter duration required in months.";
      //   isvalid = false;
      // }
      if (!state.requirementDate) {
        err.requirementDateValidation = "Please select date of requirement.";
        isvalid = false;
      }
      if (!state.purpose) {
        err.purposeValidation = "Please enter purpose.";
        isvalid = false;
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isvalid;
  };

  const handleOnAddAsset = async (e) => {
    e.preventDefault();
    try {
      if (workflowData === null) {
        await showErrorMessage(`Workflow not set for this category!!`);
        return;
      }
      if (isValidAddAssetData()) {
        let confirmationQuestion = `Are you sure you want to add a new asset?`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isAssetSubmitted: true }));
        let assetLst = [...state.assetLst];

        let assetSourceLst = {};
        assetSourceLst.NoOfRows = Math.random().toString(16).slice(2);
        assetSourceLst.categoryId = state.categoryId;
        assetSourceLst.categoryName = state.categoryName;
        assetSourceLst.subCategoryId = state.subCategoryId;
        assetSourceLst.SubCategoryName = state.subCategoryName;
        assetSourceLst.requiredQty = 1; //state.requiredQty;
        assetSourceLst.durationInMonths = state.durationInMonths;
        assetSourceLst.requestSubId = 0;
        assetSourceLst.requestId = state.requestId;
        assetSourceLst.requestNo = state.requestNo;
        assetSourceLst.requirementDate = state.requirementDate
          ? moment(state.requirementDate)
            .format(DefaultDateFormat.SqlDateFormat)
            .toString()
          : "";
        assetSourceLst.purpose = state.purpose;
        assetLst.push(assetSourceLst);
        handleOnCloseAddAssetModal();
        setState((prev) => ({
          ...prev,
          categoryId: 0,
          categoryName: "",
          subCategoryId: 0,
          subCategoryName: "",
          requiredQty: 1,
          durationInMonths: 0,
          requirementDate: "",
          purpose: "",
          assetLst: assetLst,
        }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({ ...prev, isAssetSubmitted: false }));
    }
  };

  const isValidAddAssetRequestData = () => {
    let isvalid = true;
    try {
      let err = { ...errors };
      //err.noteValidation = "";
      err.projectValidation = "";
      //err.userValidation = "";
      err.subjectValidation = "";
      //err.requestTypeValidation = "";
      //err.workflowCategoryValidation = "";

      if (state.projectId === 0) {
        err.projectValidation = "Please select project.";
        isvalid = false;
      }
      // if (state.userId === 0) {
      //   err.userValidation = "Please select user.";
      //   isvalid = false;
      // }
      // if (state.workflowCategoryId === 0) {
      //   err.workflowCategoryValidation = "Please select workflow catrgory.";
      //   isvalid = false;
      // }
      if (state.requestSubject === "") {
        err.subjectValidation = "Please enter subject.";
        isvalid = false;
      }
      // if (state.requestTypeId === 0) {
      //   err.requestTypeValidation = "Please select request type.";
      //   isvalid = false;
      // }
      // if (!state.note) {
      //   err.noteValidation = "Please enter note.";
      //   isvalid = false;
      // }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isvalid;
  };

  const handleOnSaveAssetRequest = async (e) => {
    e.preventDefault();
    try {
      if (workflowData === null) {
        await showErrorMessage(`Workflow not set for this category!!`);
        return;
      }
      if (isValidAddAssetRequestData()) {
        let confirmationQuestion = `Are you sure you want to save this asset request as a draft?`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSavingAsDraft: true }));

        const request = new Object();
        let body = {
          requestNo: state.requestNo,
          statusId: parseInt(AssetSubStatus.AssetRequestPending),
          fromId: user.userId,
          toId: state.userId,
          requestedDate: moment(state.requestedDate)
            .format(DefaultDateFormat.SqlDateTimeFullFormat)
            .toString(),
          projectId: state.projectId,
          locationName: state.locationName ?? "",
          note: state.note,
          action: 0,
          assetRequestId: state.assetRequestId,
          userId: user.userId,
          requestSubject: state.requestSubject,
          requestTypeId: state.requestTypeId,
          formId: props.featurePermission.featureId,
          applicationId: 3,
          workflowId: state.workflowId,
          formName: props?.featurePermission?.featureName,
          departmentId: state.workflowDepartmentId,
          categoryId: state.workflowCategoryId,
          isLoginUserRequester:
            assetRequestApprovers?.[0]?.actionTypeId === 8 ? false : true,
          companyId: user?.companyId || 0,
        };

        let workflowCategory = {};
        workflowCategory.formId = props?.featurePermission?.featureId;
        workflowCategory.categoryId = state.workflowCategoryId;
        workflowCategory.projectId = state.projectId;
        workflowCategory.departmentId = state.workflowDepartmentId; // user.userDepartmentId;

        request.AssetRequest = body;
        request.AssetRequestSub = state.assetLst;
        request.AssetRequestAttachment =
          assetAttachment.uploadedTemporaryAttachmentLst ?? [];
        request.WorkflowCategoryRequest = workflowCategory;

        const response = await assetService.addAssetRequest(request);
        //isConfirmed = await showResponseMessage(response);

        if (!response?.isSuccess) {
          Swal.fire("Error!", `${response?.message}`, "error");
          setState((prev) => ({ ...prev, isSavingAsDraft: false }));
          return;
        }
        // if (location?.state?.sourceUrl === "AssetRequest") {
        //   Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        //     window.location.href = `/AssetRequest`;
        //   });
        // } else {
        //   Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        //     window.location.href = `/MyTasks`;
        //   });
        // }
        isConfirmed = await showResponseMessage(response);
        if (response?.isSuccess) {
          if (user?.isIframe) {
            window.parent.postMessage(
              { type: "CLOSE_IFRAME" },
              process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
            );
            return;
          } else {
            if (location?.state?.sourceUrl === "AssetRequest") {
              navigate(`/AssetRequest`);
            } else {
              navigate(`/MyTasks`);
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({ ...prev, isSavingAsDraft: false }));
    }
  };

  const handleOnSaveAssetSendRequest = async (e) => {
    e.preventDefault();
    try {
      e.preventDefault();
      // try {
      //   let confirmationQuestion = `Are you sure want to asset request for approval?`;
      //   let isConfirmed = await askConfirmation(
      //     confirmationQuestion,
      //     "Yes",
      //     "No"
      //   );
      //   if (!isConfirmed) return;
      //   setState((prev) => ({ ...prev, isAssentApprove: true }));

      //   let body = {
      //     assetRequestId: state.assetRequestId,
      //     statusId: AssetSubStatus.AssetRequestApproved,
      //     remark: "",
      //     userId: user.userId,
      //     assetId: [],
      //   };

      //   const response = await assetService.updateAssetRequestStatus(body);
      //   if (!response?.isSuccess) {
      //     Swal.fire("Error!", `${response?.message}`, "error");
      //     setState((prev) => ({ ...prev, isAssentApprove: false }));
      //     return;
      //   }
      //   Swal.fire("Success!", `${response?.message}`, "success").then(() => {
      //     window.location.href = `/AssetRequest`;
      //   });

      // } catch (error) {
      //   console.log(error);
      // } finally {
      //   setState((prev) => ({ ...prev, isAssentApprove: false }));
      // }

      if (workflowData === null) {
        await showErrorMessage(`Workflow not set for this category!!`);
        return;
      }
      if (isValidAddAssetRequestData()) {
        let confirmationQuestion = `Are you sure you want to submit this asset request for approval?`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSending: true }));

        const request = new Object();
        let body = {
          requestNo: state.requestNo,
          statusId: parseInt(AssetSubStatus.AssetRequestSendforApproval),
          fromId: user.userId,
          toId: state.userId,
          requestedDate: moment(state.requestedDate)
            .format(DefaultDateFormat.SqlDateTimeFullFormat)
            .toString(),
          projectId: state.projectId,
          locationName: state.locationName ?? "",
          note: state.note,
          action: 0,
          assetRequestId: state.assetRequestId,
          userId: user.userId,
          requestSubject: state.requestSubject,
          requestTypeId: state.requestTypeId,
          formId: props.featurePermission.featureId,
          applicationId: 3,
          workflowId: state.workflowId,
          formName: props?.featurePermission?.featureName,
          departmentId: state.workflowDepartmentId,
          categoryId: state.workflowCategoryId,
          isLoginUserRequester:
            assetRequestApprovers?.[0]?.actionTypeId === 8 ? false : true,
        };

        let workflowCategory = {};
        workflowCategory.formId = props.featurePermission.featureId;
        workflowCategory.categoryId = state.workflowCategoryId;
        workflowCategory.projectId = state.projectId;
        workflowCategory.departmentId = state.workflowDepartmentId; // user.userDepartmentId;

        request.AssetRequest = body;
        request.AssetRequestSub = state.assetLst;
        request.AssetRequestAttachment =
          assetAttachment.uploadedTemporaryAttachmentLst ?? [];
        request.WorkflowCategoryRequest = workflowCategory;

        const response = await assetService.addAssetRequest(request);

        if (response?.isSuccess) {
          let body = {
            applicationId: 3,
            assetRequestId: state.assetRequestId,
            statusId: AssetSubStatus.AssetRequestSendforApproval,
            remark: "",
            userId: user.userId,
            isMatchedStage: false,
            assetId: [],
            isLoginUserRequester:
              assetRequestApprovers?.[0]?.actionTypeId === 8 ? false : true,
            formId: props.featurePermission.featureId,
            formName: props?.featurePermission?.featureName,
            workflowId: workflowData.id,
            WorkflowCategoryRequest: workflowCategory,
            isSentForApproval: true,
          };

          const response = await assetService.updateAssetRequestStatus(body);
          if (!response?.isSuccess) {
            Swal.fire("Error!", `${response?.message}`, "error");
            setState((prev) => ({ ...prev, isAssentApprove: false }));
            return;
          }

          //isConfirmed = await showResponseMessage(response);
          // if (location?.state?.sourceUrl === "AssetRequest") {
          //   Swal.fire("Success!", `${response?.message}`, "success").then(
          //     () => {
          //       window.location.href = `/AssetRequest`;
          //     }
          //   );
          // } else {
          //   Swal.fire("Success!", `${response?.message}`, "success").then(
          //     () => {
          //       window.location.href = `/MyTasks`;
          //     }
          //   );
          // }
        }
        isConfirmed = await showResponseMessage(response);
        if (response?.isSuccess) {
          if (user?.isIframe) {
            window.parent.postMessage(
              { type: "CLOSE_IFRAME" },
              process.env.REACT_APP_VISHWAM_BASE_URL // 👈 parent domain
            );
            return;
          } else {
            if (location?.state?.sourceUrl === "AssetRequest") {
              navigate(`/AssetRequest`);
            } else {
              navigate(`/MyTasks`);
            }
          }
        }
        // Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        //   window.location.href = `/AssetRequest`;
        // });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({ ...prev, isSending: false }));
    }
  };

  const handleInputChange = async (e, field) => {
    const value = e.value;

    let err = { ...errors };
    if (field === "requestSubject") {
      err.subjectValidation = "";
    }

    // Set the selected value in AssetItem first
    setState((prev) => ({
      ...prev,
      [field]: value,
    }));
    setErrors(err);
  };

  const handleOnCloseAddAssetModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isSaveAssetModalOpen: false,
        categoryId: 0,
        categoryName: "",
        subCategoryId: 0,
        subCategoryName: "",
        requiredQty: 1,
        durationInMonths: 0,
        requirementDate: "",
        purpose: "",
        //note: "",
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const toggleAttachmentGrid = () => {
    setShowAttachmentGrid((prev) => !prev);
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) return resolve("");

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleFileChange = async (e) => {
    try {
      const assetAttachment = Array.from(e.target.files);
      const newAttachmentPromises = assetAttachment.map(async (file) => {
        const base64 = await getBase64(file);
        return {
          noOfRows: Math.random().toString(16).slice(2),
          id: 0,
          assetFileName: file.name,
          fileSize: file.size,
          fileTypeId: 0,
          fileTypeName: "",
          filePath: "",
          fileUrl: "",
          fileData: base64,
          fileType: file.type,
          uploadDate: "",
          issueDate: "",
          expiryDate: "",
          reminderAlertDays: 0,
          remark: "",
        };
      });
      const newAttachments = await Promise.all(newAttachmentPromises);
      setAssetAttachment((prev) => {
        const existingList = prev.uploadedTemporaryAttachmentLst || [];
        return {
          ...prev,
          uploadedTemporaryAttachmentLst: [...existingList, ...newAttachments],
        };
      });
      setFiles((prevState) => [...prevState, ...assetAttachment]);
    } catch (error) {
      console.error(error);
    } finally {
      setAssetAttachment((prev) => ({ ...prev, isUploaded: false }));
    }
  };

  const handleFileRemove = (index) => {
    // let attachmentToRemove = files?.find((_, i) => i === index)
    var newfiles = assetAttachment.uploadedTemporaryAttachmentLst?.filter(
      (_, i) => i !== index
    );
    setAssetAttachment((prev) => ({
      ...prev,
      uploadedTemporaryAttachmentLst: newfiles,
    }));
  };

  const handleOnUpdateAssetRequest = async (e) => {
    e.preventDefault();
    try {
      let confirmationQuestion = `Are you sure want to udpate asset request status?`;
      let isConfirmed = await askConfirmation(
        confirmationQuestion,
        "Yes",
        "No"
      );
      if (!isConfirmed) return;
      setState((prev) => ({ ...prev, isSavingAsDraft: true }));
      let body = {
        assetRequestId: state.assetRequestId,
        statusId: 2,
        Remark: "",
        userId: user.userId,
      };

      const response = await assetService.updateAssetRequestStatus(body);
      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");
        setState((prev) => ({ ...prev, isSavingAsDraft: false }));
        return;
      }
      Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        window.location.href = `/AssetRequest`;
      });
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({ ...prev, isSavingAsDraft: false }));
    }
  };

  const GetWorkFlowForApprovers = async (
    formCategoryId,
    projectId,
    departmentId
  ) => {
    try {
      let body = {
        formId: props.featurePermission.featureId,
        categoryId: formCategoryId || 0,
        projectId: projectId || 0,
        departmentId: departmentId || 0,
        companyId: user?.companyId || 0,
      };
      if (
        body.formId > 0 &&
        body.categoryId > 0 &&
        body.projectId > 0 &&
        body.departmentId > 0
      ) {
        const response = await vishwamApi.getWorkFlowForApprovalForAsset(body);
        //console.log(JSON.stringify(response));
        setWorkflowData(response);
        const stagesWithApprovers = response?.stages
          ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
          ?.map((stage) => ({
            actionTypeName: stage?.actionTypeName?.trim(), // optional: remove extra spaces or \r\n
            approvers: stage?.approvers,
          }));
        const Approvers = response?.stages
          ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
          ?.flatMap((stage) =>
            stage?.approvers?.map((approver) => ({
              actionTypeId: stage?.actionTypeId,
              userId: approver?.userId,
              canEdit: approver?.canEdit,
              stageId: stage?.index,
            }))
          );
        setAssetRequestApprovers(Approvers);
        setAssetRequestApproversByWorkflow(stagesWithApprovers);
      }
      // console.log(Approvers);
    } catch (error) {
      console.log("Error getWorkFlowForApprovers===>", error);
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div
            className="card-header p-2"
            style={{ backgroundColor: "#e3e7ff" }}
          >
            <div className="float-left">
              <h6 className="mb-0 mt-1">
                {state.requestNo !== "" && (
                  <>
                    Request No &nbsp;-&nbsp;
                    <strong style={{ color: "#282C7D" }}>
                      {state.requestNo}
                    </strong>
                    &nbsp;&nbsp;
                  </>
                )}
                From&nbsp;-&nbsp;
                <strong style={{ color: "#282C7D" }}>
                  {user?.userDepartmentName}
                </strong>
                &nbsp;&nbsp;&nbsp;Date&nbsp;-&nbsp;
                <strong style={{ color: "#282C7D" }}>
                  {moment(new Date()).format(
                    DefaultDateFormat.MomentDisplayDateTime24AMPFormat
                  )}
                </strong>
              </h6>
            </div>
            <div className="float-right">
              {/* <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={async (e) => {
                  await handleOnUpdateAssetRequest(e);
                }}
              >
                <span title="Approve">
                  <i className="fas fa-check" />
                  &nbsp;&nbsp;Approve
                </span>
              </button>
              &nbsp;&nbsp; */}
              {!user?.isIframe && (
                <>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => {
                      // navigate(
                      //   (sourceUrl.sourceUrl !== null || sourceUrl.sourceUrl !== undefined)
                      //     ? "/" + sourceUrl.sourceUrl
                      //     : "AssetRequest"
                      // );
                      if (location?.state?.sourceUrl === "AssetRequest") {
                        navigate("/AssetRequest");
                      } else {
                        navigate("/MyTasks");
                      }
                    }}
                  // onClick={() => {
                  //   navigate(
                  //     sourceUrl.sourceUrl !== null &&
                  //       sourceUrl.sourceUrl !== undefined
                  //       ? "/" + sourceUrl.sourceUrl
                  //       : "AssetRequest"
                  //   );
                  // }}
                  >
                    <span title="Cancel ">
                      <i className="fas fa-times" />
                      &nbsp;&nbsp;Cancel
                    </span>
                  </button>
                </>
              )}
              {/* <Link to={"/AssetReq"} className="btn btn-outline-primary btn-sm">
                <span title="Cancel">
                  <i className="fas fa-times"></i> Cancel
                </span>
              </Link> */}
              &nbsp;&nbsp;
              {state.stageApproved === false && (
                <>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    onClick={async (e) => {
                      await handleOnSaveAssetRequest(e);
                    }}
                  >
                    <span title="Save As Draft">
                      <i
                        className={`fas fa-${state.isSavingAsDraft
                            ? "spinner fa-spin"
                            : "file-signature"
                          }`}
                      />
                      &nbsp;&nbsp;Save As Draft
                    </span>
                  </button>
                  &nbsp;&nbsp;
                </>
              )}
              {location?.state?.requestId > 0 &&
                (state?.statusId === AssetSubStatus.AssetRequestPending ||
                  location?.state?.statusId ===
                  AssetSubStatus.AssetRequestRecall) && (
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={async (e) => {
                      await handleOnSaveAssetSendRequest(e);
                    }}
                    disabled={false}
                  >
                    <span title="Send">
                      <i
                        className={`fas fa-${state.isSending ? "spinner fa-spin" : "check"
                          }`}
                      />
                      &nbsp;&nbsp;Send for Approval
                    </span>
                  </button>
                )}
            </div>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-12 col-lg-4">
                <div className="form-group mb-2">
                  <label>
                    Project<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={projectDropdown}
                    className={`form-control ${errors.projectValidation ? "is-invalid" : ""
                      }`}
                    classNamePrefix="select"
                    placeholder="Select project"
                    name="projectDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.projectId}
                    defaultValue={state.projectId}
                    showClearButton={true}
                    disabled={
                      state.statusId === AssetSubStatus.AssetRequestBackToDraft
                        ? true
                        : false
                    }
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.projectValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        projectId: e?.selectedItem?.id ?? 0,
                        locationName: e?.selectedItem?.location ?? "",
                      }));
                      //await getWorkflowCategory(e?.selectedItem?.id ?? 0);
                      await getWorkflowDepartmentDropdown(
                        e?.selectedItem?.id ?? 0
                      );
                    }}
                  />
                  {state.locationName !== "" &&
                    state.locationName !== undefined && (
                      <div className="text-success">
                        <small>
                          <b>[{state.locationName}]</b>
                        </small>
                      </div>
                    )}
                  {errors.projectValidation && (
                    <div className="text-danger">
                      {errors.projectValidation}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-4">
                <div className="form-group mb-2">
                  <label>
                    Department<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={workflowDepartmentDropdown}
                    className={`form-control ${errors.workflowDepartmentValidation ? "is-invalid" : ""
                      }`}
                    classNamePrefix="select"
                    placeholder="Select department"
                    name="workflowDepartmentDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.workflowDepartmentId}
                    defaultValue={state.workflowDepartmentId}
                    showClearButton={true}
                    disabled={
                      state.statusId === AssetSubStatus.AssetRequestBackToDraft
                        ? true
                        : false
                    }
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.workflowDepartmentValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        workflowDepartmentId: e?.selectedItem?.id ?? 0,
                        workflowCategoryId: 0,
                        departmentId: e?.selectedItem?.id ?? 0,
                      }));
                      //await getWorkflowCategory(e?.selectedItem?.id ?? 0);
                      await getWorkflowCategory(
                        state.projectId,
                        e?.selectedItem?.id ?? 0
                      );
                    }}
                  />
                  {errors.workflowDepartmentValidation && (
                    <div className="text-danger">
                      {errors.workflowDepartmentValidation}
                    </div>
                  )}
                </div>
              </div>
              {/* {workflowCategoryDropdown?.length > 1 && (
                <div className="col-12 col-lg-4">
                  <div className="form-group mb-2">
                    <label>
                      Category<span className="text-danger">*</span>
                    </label>
                    <div className="d-flex">
                      <SelectBox
                        dataSource={workflowCategoryDropdown}
                        className={`form-control ${errors.workflowCategoryValidation ? "is-invalid" : ""
                          }`}
                        classNamePrefix="select"
                        placeholder="Select category"
                        name="workflowCategoryDropdown"
                        displayExpr="name"
                        valueExpr="workflowCategoryId"
                        value={state.workflowCategoryId}
                        defaultValue={state.workflowCategoryId}
                        showClearButton={true}
                        disabled={false}
                        searchEnabled={true}
                        onSelectionChanged={async (e) => {
                          let err = { ...errors };
                          err.workflowCategoryValidation = "";
                          setErrors(err);
                          setState((prev) => ({
                            ...prev,
                            workflowCategoryId:
                              e?.selectedItem?.workflowCategoryId ?? 0,
                            workflowId: e?.selectedItem?.workflowId ?? 0,
                          }));
                        }}
                      />
                    </div>
                    {errors.workflowCategoryValidation && (
                      <div className="text-danger">
                        {errors.workflowCategoryValidation}
                      </div>
                    )}
                  </div>
                </div>
              )} */}
            </div>
            <div className="row">
              <div className="col-12 col-lg-8">
                <div className="form-group mb-2">
                  <label>
                    Subject<span className="text-danger">*</span>
                  </label>
                  <TextBox
                    className="form-control"
                    placeholder="Enter Subject"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    allowEditing={false}
                    value={state.requestSubject}
                    onValueChanged={(e) =>
                      handleInputChange(e, "requestSubject")
                    }
                  />
                  {errors.subjectValidation && (
                    <div className="text-danger">
                      {errors.subjectValidation}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="form-group mb-2">
                  <DataGrid
                    dataSource={state.assetLst}
                    showBorders={true}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                    showRowLines={true}
                    showColumnLines={false}
                    height={200}
                    onToolbarPreparing={(e) => {
                      e.toolbarOptions.items.unshift({
                        location: "before",
                        widget: "dxButton",
                        options: {
                          text: "Add Asset",
                          icon: "plus",
                          stylingMode: "outlined",
                          type: "default", // you can use 'success', 'danger', etc.
                          onClick: () => {
                            if (state.workflowDepartmentId === 0) {
                              let alertMessage = `Please select department`;
                              let isConfirmed = showWarningMessage(
                                alertMessage,
                                "Warning"
                              );
                              return;
                            }
                            setState((prev) => ({
                              ...prev,
                              isSaveAssetModalOpen: true,
                            }));
                          },
                        },
                      });
                    }}
                  >
                    <Column
                      dataField="NoOfRows"
                      caption=""
                      allowSorting={false}
                      allowSearch={false}
                      allowExporting={false}
                      allowFiltering={false}
                      width={30}
                      cellRender={(data) => {
                        return (
                          data?.data?.requestSubId === 0 && (
                            <span>
                              <Icon
                                className="iconify-size"
                                title="Delete"
                                tooltip="Delete"
                                icon="fluent:delete-32-regular"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  setState((prev) => ({
                                    ...prev,
                                    assetLst:
                                      data?.data.requestSubId === 0
                                        ? state.assetLst?.filter(
                                          (f) =>
                                            f.NoOfRows !== data?.data.NoOfRows
                                        )
                                        : state.assetLst?.filter(
                                          (f) =>
                                            f.requestSubId !==
                                            data?.data.requestSubId
                                        ),
                                  }));
                                }}
                              />
                            </span>
                          )
                        );
                      }}
                    />
                    <Column
                      dataField="categoryName"
                      caption="Asset Description"
                      allowSearch={true}
                    />
                    <Column
                      dataField="requiredQty"
                      caption="Required Qty"
                      allowSearch={true}
                      alignment={"center"}
                    />
                    <Column
                      dataField="durationInMonths"
                      caption="Duration Required (In Months)"
                      allowSearch={true}
                      alignment={"center"}
                    />
                    <Column
                      dataField="requirementDate"
                      caption="Date Of Requirement"
                      allowSearch={true}
                      dataType="date"
                      format={DefaultDateFormat.GridDateFormat}
                    />
                    <Column
                      dataField="purpose"
                      caption="Purpose"
                      allowSearch={true}
                    />
                    <HeaderFilter visible={false} />
                    <Scrolling mode="virtual" />
                    <SearchPanel
                      visible={true}
                      highlightCaseSensitive={true}
                      width={240}
                      placeholder="Search..."
                    />
                  </DataGrid>
                </div>
              </div>
            </div>
            <div className="mb-1">
              <div className="form-group">
                {/* <span onClick={() => { console.log(files) }}>console</span> */}
                <label
                  htmlFor="fileUpload"
                  className="btn btn-outline-primary mb-1"
                  style={{ cursor: "pointer", padding: "0.23rem 0.35rem" }}
                  title="Attachment"
                >
                  {" "}
                  <i className="fas fa-plus"></i> Attachment{" "}
                </label>
                <input
                  id="fileUpload"
                  type="file"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              </div>
              <div className="attachment-container">
                {assetAttachment?.uploadedTemporaryAttachmentLst?.map(
                  (file, idx) => (
                    <div key={idx} className="attachment-item">
                      <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                      >
                        <div
                          className="attachment-name"
                          onClick={() => {
                            if (file?.filePath) {
                              window.open(file?.fileUrl, "_blank");
                            }
                          }}
                        >
                          {file?.assetFileName}
                        </div>
                        {file?.id === 0 && (
                          <button
                            className="btn pt-0 pb-0 pr-0"
                            onClick={() => handleFileRemove(idx)}
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        )}
                      </div>
                      <div className="small">
                        {(file?.fileSize / 1024).toFixed(0)} kb
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            {/* <div className="row">
              <div className="col-12 col-lg-6">
                <div className="form-group mb-2">
                  <label>
                    Note<span className="text-danger">*</span>
                  </label>
                  <TextArea
                    className={`form-control ${errors.noteValidation ? "is-invalid" : ""
                      }`}
                    placeholder="Enter note"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={state.note}
                    onValueChanged={(e) => {
                      let err = { ...errors };
                      err.noteValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        note: e?.value,
                      }));
                    }}
                  />
                  {errors.noteValidation && (
                    <div className="text-danger">{errors.noteValidation}</div>
                  )}
                </div>
              </div>
            </div> */}
            <div className="row">
              {/* <div className="col-lg-4 col-md-12 col-sm-4">
                <div className="form-group">
                  <label>Prepared By</label>
                  {stateData?.requestId ? (
                    <TextBox
                      className="form-control"
                      placeholder="Enter name"
                      showClearButton={false}
                      value={
                        stateData?.fromName +
                        " (" +
                        stateData?.fromDesignation +
                        ")"
                      }
                      readOnly={true}
                    />
                  ) : (
                    <TextBox
                      className="form-control"
                      placeholder="Enter name"
                      showClearButton={false}
                      value={
                        user?.firstName +
                        " " +
                        user?.lastName +
                        " (" +
                        user?.userDesignationName +
                        ")"
                      }
                      readOnly={true}
                    />
                  )}
                </div>
              </div> */}

              {assetRequestApprovers?.[0]?.actionTypeId === 8 ? (
                ""
              ) : (
                <>
                  <div className="col-lg-4 col-md-12 col-sm-4">
                    <div className="form-group">
                      {assetRequestApprovers?.[0]?.actionTypeId === 8 ? (
                        ""
                      ) : (
                        <label>Prepared By</label>
                      )}
                      {assetRequestApprovers?.id ? (
                        <TextBox
                          className="form-control"
                          placeholder="Enter name"
                          showClearButton={false}
                          value={
                            assetRequestApprovers?.fromUser +
                            " (" +
                            assetRequestApprovers?.fromUserDesignation +
                            ")"
                          }
                          readOnly={true}
                        />
                      ) : assetRequestApprovers?.[0]?.actionTypeId === 8 ? (
                        ""
                      ) : (
                        <TextBox
                          className="form-control"
                          placeholder="Enter name"
                          showClearButton={false}
                          value={
                            user?.firstName +
                            " " +
                            user?.lastName +
                            " (" +
                            user?.userDesignationName +
                            ")"
                          }
                          readOnly={true}
                        />
                      )}
                    </div>
                  </div>
                </>
              )}

              {assetRequestApproversByWorkflow?.map((stage, index) => (
                <div
                  key={index}
                  className="col-lg-4 col-md-12 col-sm-4 d-flex align-items-start"
                >
                  <div className="w-100">
                    <label className="form-label">
                      {stage?.actionTypeName}
                    </label>
                    {stage?.approvers?.map((approver, i) => (
                      <input
                        key={i}
                        type="text"
                        className="form-control"
                        value={`${approver?.userName} (${approver?.designationName})`}
                        readOnly
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Modal
        ariaHideApp={false}
        isOpen={state.isSaveAssetModalOpen}
        onAfterOpen={async () => {
          await getCategoryDropdown(state?.workflowDepartmentId || 0);
          if (state.categoryId > 0) {
            await getSubCategoryDropdown(state?.categoryId);
          }
          let err = { ...errors };
          err.categoryValidation = "";
          err.subCategoryValidation = "";
          //err.requiredQtyValidation = "";
          err.durationInMonthsValidation = "";
          err.requirementDateValidation = "";
          err.purposeValidation = "";
          err.workflowCategoryValidation = "";
          setErrors(err);
        }}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Add/Edit Asset Modal"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {state.assedId > 0 ? `Update Asset For:-` : `Add Asset`}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseAddAssetModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-6">
              <div className="form-group mb-2">
                <label>
                  Category<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={categoryDropdown}
                  className={`form-control-${errors.categoryValidation ? "is-invalid" : ""
                    }`}
                  classNamePrefix="select"
                  placeholder="Select category"
                  name="categoryDropdown"
                  displayExpr="name"
                  valueExpr="id"
                  value={state.categoryId}
                  defaultValue={state.categoryId}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.categoryValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      categoryId: e?.selectedItem?.id ?? 0,
                      categoryName: e?.selectedItem?.name ?? "",
                      subCategoryId: 0,
                      subCategoryName: "",
                    }));
                    setSubCategoryDropdown([]);
                    if (e?.selectedItem?.id > 0) {
                      await getSubCategoryDropdown(e?.selectedItem?.id);
                    }
                  }}
                />
                {errors.categoryValidation && (
                  <div className="text-danger">{errors.categoryValidation}</div>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="form-group mb-2">
                <label>
                  Sub Category<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={subCategoryDropdown}
                  className={`form-control-${errors.subCategoryValidation ? "is-invalid" : ""
                    }`}
                  classNamePrefix="select"
                  placeholder="Select sub category"
                  name="subCategoryDropdown"
                  displayExpr="name"
                  valueExpr="id"
                  value={state.subCategoryId}
                  defaultValue={state.subCategoryId}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.subCategoryValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      subCategoryId: e?.selectedItem?.id ?? 0,
                      subCategoryName: e?.selectedItem?.name ?? "",
                    }));
                  }}
                />
                {errors.categoryValidation && (
                  <div className="text-danger">{errors.categoryValidation}</div>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            {/* <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>
                  Required Qty<span className="text-danger">*</span>
                </label>
                <NumberBox
                  height={38}
                  name="reminderAlertDays"
                  className={`form-control ${
                    errors.requiredQtyValidation ? "is-invalid" : ""
                  }`}
                  placeholder="Enter required qty"
                  showClearButton={true}
                  valueChangeEvent="keyup"
                  onValueChanged={(e) => {
                    let err = { ...errors };
                    err.requiredQtyValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      requiredQty: e?.value,
                    }));
                  }}
                  value={Number(state.requiredQty ?? 0) || ""}
                />
                {errors.requiredQtyValidation && (
                  <div className="text-danger">
                    {errors.requiredQtyValidation}
                  </div>
                )}
              </div>
            </div> */}
            <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>Duration Required (In Months)</label>
                <NumberBox
                  height={38}
                  name="durationInMonths"
                  className={`form-control ${errors.durationInMonthsValidation ? "is-invalid" : ""
                    }`}
                  placeholder="Enter duration required in month"
                  showClearButton={true}
                  valueChangeEvent="keyup"
                  onValueChanged={(e) => {
                    let err = { ...errors };
                    err.durationInMonthsValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      durationInMonths: e?.value,
                    }));
                  }}
                  value={Number(state.durationInMonths ?? 0) || ""}
                />
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>
                  Date Of Requirement
                  <span className="text-danger">*</span>
                </label>
                <DateBox
                  type="date"
                  className={`form-control ${errors.requirementDateValidation ? "is-invalid" : ""
                    }`}
                  name="requirementDate"
                  placeholder={DefaultDateFormat.GridDateFormat}
                  displayFormat={DefaultDateFormat.GridDateFormat}
                  showAnalogClock={false}
                  useMaskBehavior={false}
                  defaultValue={state.requirementDate}
                  value={state.requirementDate}
                  disabled={false}
                  acceptCustomValue={true}
                  //min={moment(new Date(), "MM/DD/YYYY").add(1, "day")}
                  min={moment(new Date(), "MM/DD/YYYY").add(1, "day")}
                  onValueChanged={(date) => {
                    let err = { ...errors };
                    err.requirementDateValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      requirementDate: date.value,
                    }));
                  }}
                />
                {errors.requirementDateValidation && (
                  <div className="text-danger">
                    {errors.requirementDateValidation}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="form-group mb-2">
                <label>
                  Purpose<span className="text-danger">*</span>
                </label>
                <TextArea
                  className={`form-control ${errors.purposeValidation ? "is-invalid" : ""
                    }`}
                  placeholder="Enter purpose"
                  showClearButton={true}
                  valueChangeEvent="keyup"
                  value={state.purpose}
                  onValueChanged={(e) => {
                    let err = { ...errors };
                    err.purposeValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      purpose: e?.value,
                    }));
                  }}
                />
                {errors.purposeValidation && (
                  <div className="text-danger">{errors.purposeValidation}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseAddAssetModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={async (e) => {
              await handleOnAddAsset(e);
            }}
            disabled={state.isAssetSubmitted}
          >
            <span title="Submit">
              <i
                className={`fas fa-${state.isAssetSubmitted ? "spinner fa-spin" : "check"
                  }`}
              />
              &nbsp;&nbsp;Submit
            </span>
          </button>
        </div>
      </Modal>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
